import InsuranceComponent from "@components/User/Insurance/Insurance";

export default function UserInsurance() {
  return <InsuranceComponent />;
}
